import {useState} from "react";
import {acceptCookie} from "@/features/cookie";

type Params = {
    hideCookie: boolean;
}

export const useCookie = ({hideCookie}: Params) => {
    const [accepted, setAccepted] = useState(false);

    const close = () => {
        setAccepted(true); // скрываем сразу, не ждем сервер

        acceptCookie();
    };

    return {
        hide: accepted || hideCookie,
        close,
    };
};
